import React, { Children } from 'react';
import {
  makeStyles,
  Step,
  StepConnector,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from '@material-ui/core';
import { ShowChart } from '@material-ui/icons';
import ViewMore from '../../../../../SharedComponents/ViewMore/ViewMore';
import {
  GetGeneralClientTrackingActivity,
  GetVendorClientTrackingActivity,
} from '../../../../../Services';
import useFetchList from '../../../../../Hooks/useFetchData';
import { Spinner } from '../../../../../Components';
import moment from 'moment';

const formatActivityDate = (dateStr) => {
  const date = moment(dateStr);
  const now = moment();

  if (now.diff(date, 'hours') < 24) {
    return date.fromNow(); // e.g., "6 hours ago"
  }

  return date.format('h:mma D MMM YYYY'); // e.g., "4:16pm 20 Jan 2024"
};
const styles = makeStyles({
  stepIcon: {
    background: '#F2F4F7',
    borderRadius: '100%',
    padding: '6px',
  },
  stepper: {
    padding: '0',
  },
});
const ActivitiesTimeline = ({
  vendorClientTrackingId,
  generalClientTrackingId,
}) => {
  const classes = styles();
  const { data: activities, loading } = useFetchList(
    vendorClientTrackingId
      ? GetVendorClientTrackingActivity
      : GetGeneralClientTrackingActivity,
    vendorClientTrackingId ?? generalClientTrackingId
  );
  if (loading) {
    return <Spinner isActive={loading} isAbsolute />;
  }
  return (
    <div className='p-relative'>
      {activities.result?.length ? (
        Children.toArray(
          activities.result.map(({ activity }, index) => (
            <Stepper orientation='vertical' className={classes.stepper}>
              <Step key={index}>
                <StepLabel
                  StepIconComponent={() => (
                    <ShowChart className={classes.stepIcon} fontSize='large' />
                  )}
                >
                  <Typography variant='body1'>
                    <strong>{activity.subject}</strong>
                    <Typography variant='body2'>
                      {formatActivityDate(activity.createdOn)}
                    </Typography>
                  </Typography>
                </StepLabel>
                <StepContent>
                  <ViewMore>{activity.comments}</ViewMore>
                </StepContent>
              </Step>
              <StepConnector />
            </Stepper>
          ))
        )
      ) : (
        <Typography variant='subtitle2'>
          No activities found for this record
        </Typography>
      )}
    </div>
  );
};
export default ActivitiesTimeline;
